import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDropDown = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M6 8 2 4h8z" })
});
export default SvgArrowDropDown;
